import { z } from "zod";

import { constants } from "@north-beam/nb-common";

import { AmplitudeEventIds } from "../constants";

import { amplitudeEvent } from "./base";

export const ExportSalesChartDataEvent = amplitudeEvent(
  {
    id: "export-sales-chart-data",
    camelCaseName: "exportSalesChartData",
    label: "Export Sales Chart Data",
  },
  {
    accountingMode: constants.AccountingModes.schema,
    attributionModel: z.string(),
    timeGranularity: constants.TimeGranularities.schema,
    attributionWindow: constants.AttributionWindows.schema,
    dateRange: z.union([
      z.object({ startDate: z.string(), endDate: z.string() }),
      constants.DateRanges.schema,
    ]),
  },
);

export const SalesPageUpdateBreakdowns = amplitudeEvent(
  {
    id: AmplitudeEventIds.SALES_PAGE_UPDATE_BREAKDOWNS,
    camelCaseName: "salesPageUpdateBreakdowns",
    label: "Sales page update breakdowns",
  },
  {
    breakdowns: z.array(
      z.object({
        key: z.string(),
        values: z.array(z.string()),
      }),
    ),
  },
);

export const SalesPageExportScheduled = amplitudeEvent(
  {
    id: AmplitudeEventIds.SALES_PAGE_EXPORT_SCHEDULED,
    camelCaseName: "salesPageExportScheduled",
    label: "Sales page export scheduled",
  },
  {
    details: z.any(),
  },
);

export const SalesPageExportNow = amplitudeEvent(
  {
    id: AmplitudeEventIds.SALES_PAGE_EXPORT_NOW,
    camelCaseName: "salesPageExportNow",
    label: "Sales page export now",
  },
  {
    details: z.any(),
  },
);

export const SALES_PAGE_EVENTS = [
  SalesPageUpdateBreakdowns,
  ExportSalesChartDataEvent,
  SalesPageExportScheduled,
  SalesPageExportNow,
] as const;
